import {gql} from '@apollo/client';

export const lookupQueries = {
    LOOKUPS: gql`
        query GetLookUps(
            $where: LookUpFilterInput
            $order: [LookUpSortInput!]
            $search: String
            $after: String
            $before: String
            $first: Int
            $last: Int
        ) {
            lookUps(
                where: $where
                order: $order
                search: $search
                after: $after
                before: $before
                first: $first
                last: $last
            ) {
                edges {
                    cursor
                }
                nodes {
                    id
                    title
                    data
                    category
                    parentId
                    type
                    description
                    active
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
            }
        }
    `,
    GET_LOOKUP_BY_ID: gql`
        query ($id: UUID!) {
            lookUpById(id: $id) {
                id
                title
                data
                category
                parentId
                type
                description
                active
            }
        }
    `,
    GET_ALL_LOOKUP_TYPES: gql`
        query AllLookUpsTypes($search: String) {
            allLookupTypes(search: $search)
        }
    `,
    GET_ALL_LOOKUP_CATEGORIES: gql`
        query AllLookUpsCategories($search: String) {
            allLookupCategories(search: $search)
        }
    `,
    GET_ALL_TYPES_BASED_ON_CATEGORY: gql`
        query AllTypesBaseOnCategory($category: String!, $search: String) {
            allTypesBasedOnCategory(category: $category, search: $search)
        }
    `,
    GET_ALL_LOOKUP_BASED_ON_TYPE: gql`
        query AllLookUpsBasedOnType($type: String!, $search: String) {
            lookUps(where: {type: {eq: $type}}, search: $search) {
                nodes {
                    id
                    title
                    type
                }
            }
        }
    `,
    GET_ALL_LOOKUP_BASED_ON_TYPE_AND_PARENT_ID: gql`
        query allLookUpsBasedOnTypeAndParentId($type: String!, $parentId: UUID!, $search: String) {
            lookUps(search: $search, where: {type: {eq: $type}, parentId: {eq: $parentId}}) {
                nodes {
                    id
                    title
                    type
                }
            }
        }
    `,
    GET_ALL_LOOKUPS_ID_AND_TITLE: gql`
        query AllLookUpsIdAndTitle($lookUpType: String!, $search: String!) {
            allLookUps(lookUpType: $lookUpType, search: $search) {
                nodes {
                    id
                    title
                    data
                    category
                    parentId
                    type
                    description
                    active
                }
            }
        }
    `,
};
